import { useState } from 'react';
import UseContext from 'hooks/useContext';
import BillingExternalView from './BillingExternalView';

/**
 * « Modifier le contact de facturation » for a contact without an account
 * (JBWEB-1285, mockup 8.6).
 */
const ModalEditBillingContact = () => {
  const { language, modalData } = UseContext();
  // Read once: « Inviter sur Jobbiz » replaces « modalData » for the next modal
  // while this one is still on screen.
  const [{ idCompany, contact }] = useState(() => ({
    idCompany: modalData?.idCompany,
    contact: modalData?.contact ?? {},
  }));

  return (
    <BillingExternalView
      idCompany={idCompany}
      contact={contact}
      title={language.getValue('companyBillingContacts.external.editTitle', '')}
    />
  );
};

export default ModalEditBillingContact;
